import React from 'react';
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';
import { FormatDateUK, getStatus } from '../../helpers';
import Status from './status';

const DescriptionDiv = styled.div`
                        color:#989798;

                       .bold{
                           color:#000000;
                       }
                       .modal-title{
                           color:#000;
                       }

                       .initials{
                            background: #e5f3fe;
                            width: 60px;
                            height: 60px;
                            margin: auto;
                            line-height: 60px;
                            border-radius: 50%;
                            color: #0184fe;
                            display: inline-block;
                            text-align:center;
                       }

                       .status{
                        margin-top: 10px;
                        border-radius: 10px;
                        min-height:20px;
                        color: #000;
                        text-align: center;
                        display: block;
                        font-weight: bold;
                       }
                       	
`
const EditButton = styled.button`
                    position: absolute;
                    top: 10px;
                    right: 100px;
                    background: #d9001c;
                    color: #fff;
                    padding: 10px 30px;
                    border-radius: 8px;
                    border:0px;
`

const getUser = function (user, index) {
    return <div className="initials" key={index}>
        {user.name.charAt(0)}
        {user.surname.charAt(0)}
    </div>
}
const Description = (props) => {
    let department = props.departments[props.departments.findIndex(x => x.slug === props.item.dept)];

    let category;
    if (props.item.category === 'top-level') {
        category = { 'name': 'Top level' };
    } else {
        let categories = Object.values(department.categories);
        let catIndex = Object.values(department.categories).findIndex(x => x.slug === props.item.category);
        category = Object.values(department.categories)[catIndex];
    }

    const updateStatus = () => {

    }
    return (
        <DescriptionDiv>
            <Modal.Header closeButton>
                <Modal.Title>{props.item.name}</Modal.Title>
                {props.currentUser.role && props.currentUser.role === 'admin' ?
                    <EditButton onClick={props.edit} className="show-desktop">Edit {props.deliverable ? 'Deliverable' : 'Activity'}</EditButton>
                    : ''}
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-sm-12 col-lg-7">
                        <div className="row pb-3">
                            <div className="col-12">
                                <span className="bold">Description</span><br />
                                {props.item.description}
                            </div>
                        </div>
                        <div className="row pb-3">
                            <div className="col-12">
                                <span className="bold">Owners</span><br />
                                {(props.item.users && props.item.users.length > 0) ? props.item.users.map((value, index) => (
                                    getUser(value, index)
                                ))
                                    : ''
                                }
                            </div>
                        </div>
                        {props.item.dependencies && props.item.dependencies.length > 0 ?
                            <div className="row pb-3">
                                <div className="col-12">
                                    <span className="bold">Dependencies</span><br />
                                    {props.item.dependencies && props.item.dependencies.length > 0 ? Object.values(props.item.dependencies).map((value, index) => (

                                        index !== 0 ? `, ${value.name}` : value.name

                                    ))
                                        : ''
                                    }
                                </div>
                            </div>
                            : ''}
                        <div className="row pb-3">
                            <div className="col-12">
                                <span className="bold">Department</span><br />
                                {department.name}
                            </div>
                        </div>
                        {!props.deliverable ?
                            <div className="row pb-3">
                                <div className="col-12">
                                    <span className="bold">Category</span><br />
                                    {category.name}
                                </div>
                            </div>
                            : ''}
                    </div>
                    <div className="col-sm-12 col-lg-5">
                        <div className="row pb-3">
                            <div className="col-12">
                                <span className="bold">Start Date</span><br />
                                {FormatDateUK(props.item.start)}
                            </div>
                        </div>
                        <div className="row pb-3">
                            <div className="col-12">
                                <span className="bold">Due Date</span><br />
                                {FormatDateUK(props.item.finish)}
                            </div>
                        </div>
                        <div className="row pb-3">
                            <div className="col-12">
                                <span className="bold">Status</span><br />
                                <div className={`status ${getStatus(props.item, props.dependencies)}`}>{getStatus(props.item, props.dependencies)}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>

            </Modal.Footer>
        </DescriptionDiv>
    );
}

export default Description;
